import { ActivityText, TextActivityCard } from "@adsk/alloy-react-activity-log";
import React from "react";
import { ActivityLogCardProps } from "../activityLogTypes";
import { activityTextDefaultStyle } from "./activityTextDefaultStyle";

export const ChangedTextActivityCard = ({
  activityChange,
  isAggregated,
  ...props
}: ActivityLogCardProps) => {
  const { after } = activityChange;

  return isAggregated ? (
    <ActivityText text={after} style={activityTextDefaultStyle} />
  ) : (
    <TextActivityCard
      /* Used by globals.ts to amend UI issues until https://jira.autodesk.com/browse/WPLT-1164 is fixed */
      className="IssuesActivityLog__activity-card"
      text={after}
      data-testid="text-activity-card"
      {...props}
      style={activityTextDefaultStyle}
    />
  );
};
